var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgLoaderLogo = function SvgLoaderLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.0348 100.233C125.415 58.8397 92.1363 17.1601 68.3936 0.36099C67.566 -0.224576 66.4182 -0.030086 65.7693 0.748837C20.8205 54.704 55.125 88.0887 77.7865 100.531C78.5133 100.93 79.4222 100.791 80.0348 100.233Z",
    fill: "#FDEDEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1387 99.9564C84.5933 38.7768 31.8937 30.5632 3.04157 34.2358C2.03587 34.3638 1.32163 35.2831 1.37009 36.2957C4.72646 106.44 52.5739 107.848 77.6836 101.696C78.4889 101.499 79.0651 100.782 79.1387 99.9564Z",
    fill: "#F47A87"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9056 100.741C79.0327 100.504 79.1137 100.24 79.1383 99.9633C82.3419 64.0316 65.4858 46.37 45.1826 38.6561C37.8748 70.6451 61.018 91.3182 77.7864 100.525C78.1351 100.716 78.5258 100.784 78.9056 100.741Z",
    fill: "#ECC7CB"
  })));
};
var Memo = /*#__PURE__*/memo(SvgLoaderLogo);
export default Memo;